import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import userService from '../services/userService';
import UserTable from '../components/UserTable';

const UsersPage = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(25);
  const [total, setTotal] = useState(0);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await userService.getUsers(token, { page, limit });
      setUsers(response.results);
      setTotal(response.count);
    } catch (err) {
      console.error('Failed to fetch users:', err);
    } finally {
      setLoading(false);
    }
  }, [token, page, limit]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleToggleActive = async (userId, isActive) => {
    try {
      await userService.toggleActive(token, userId, isActive);
      setUsers(users.map(u => u.id === userId ? { ...u, is_active: isActive } : u));
    } catch (err) {
      console.error('Failed to toggle active:', err);
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    try {
      await userService.deleteUser(token, userId);
      setUsers(users.map(u => u.id === userId ? { ...u, deleted: true } : u));
    } catch (err) {
      console.error('Failed to delete user:', err);
    }
  };

  return (
    <div style={{ padding: '20px 40px', marginLeft: 'auto', marginRight: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h1 style={{ color: '#3D3D3D', marginBottom: 0 }}>Users</h1>
        <button
          onClick={() => navigate('/users/create')}
          style={{
            backgroundColor: '#A0BD46',
            color: 'white',
            border: 'none',
            padding: '12px 20px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          + Add User
        </button>
      </div>
      <UserTable
        users={users}
        onEdit={(id) => navigate(`/users/${id}/edit`)}
        onToggleActive={handleToggleActive}
        onDelete={handleDelete}
        loading={loading}
      />
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>Total: {total} | Page {page} of {Math.ceil(total / limit)}</div>
        <div>
          <button onClick={() => setPage(Math.max(1, page - 1))} disabled={page === 1} style={{ marginRight: '10px', padding: '8px 16px' }}>
            Previous
          </button>
          <button onClick={() => setPage(page + 1)} disabled={page * limit >= total} style={{ padding: '8px 16px' }}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default UsersPage;
